import CertifiedProgramOffer from './CertifiedProgramOffer';
export default CertifiedProgramOffer;